import { apiSlice } from "../../apiSlice";

export interface HealthCheckResponse {
  is_under_maintenance: boolean;
  maintenance_end_time?: string;
  maintenance_message?: string;
}

export interface HealthCheckError {
  status: number;
  data: HealthCheckResponse;
}

export const healthApiSlice = apiSlice.injectEndpoints({
	endpoints: (builder) => ({
		getHealthCheck: builder.query<HealthCheckResponse, void>({
			query: () => "/health/",
		}),
	}),
});

export const { useGetHealthCheckQuery } = healthApiSlice;